import type { Permission } from "@/lib/permissions";
import type { NavigationSlug } from "@/types";

export const NAV_SLUG_PERMISSIONS: Record<NavigationSlug, Permission[]> = {
  home_projects: [
    "page:home",
    "panel:projects",
    "card:recent_avi",
    "card:deadline",
    "card:workflow",
    "card:avi_list",
    "card:team_overview",
  ],
  home_avi: ["page:home", "panel:avi", "card:workflow", "card:avi_list", "card:project_overview"],
  evidence: ["page:evidence"],
  issue: ["page:issue"],
  organizations: ["page:organization"],
  users: ["page:users"],
  ai_diagnostic: ["page:ai_diagnostic"],
  report: ["page:report"],
  projects: ["page:projects"],
  standards: ["page:standards"],
};
